import {Grid, Stack, Switch, TextField, Typography} from '@mui/material';
import React, {useState} from 'react';
import DropZone from '../../generalPurpose/DropZone';
import {isImageLinkValidator} from '../../../../Util/validators';

type Props = {
  item: any;
  index: number;
  setDisplayPocToolContent: Function;
  handleTextFieldOnChange: Function;
  handleSetThumbnail: Function;
  displayPocToolContent: any;
};

export default function ImageLoader(props: Props) {
  const {
    displayPocToolContent,
    setDisplayPocToolContent,
    handleTextFieldOnChange,
    handleSetThumbnail,
    index,
    item,
  } = props;

  const [isImageLink, setIsImageLink] = useState(
    isImageLinkValidator(item.value),
  );

  const handleImageOnChange = () => {
    setDisplayPocToolContent(
      displayPocToolContent.map((item, itemIndex) => {
        if (itemIndex === index)
          return {
            ...item,
            value: '',
          };
        return item;
      }),
    );
    return setIsImageLink(!isImageLink);
  };

  return (
    <Grid style={styles.container}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography>File</Typography>
        <Switch
          checked={isImageLink}
          inputProps={{'aria-label': 'ant design'}}
          onChange={handleImageOnChange}
        />
        <Typography>Link</Typography>
      </Stack>
      {isImageLink ? (
        <TextField
          id="outlined-basic"
          value={item.value}
          style={styles.textFieldStyle}
          variant="standard"
          onChange={handleTextFieldOnChange}
        />
      ) : (
        <DropZone
          isValid={true}
          thumbnail={item.value}
          setThumbnail={handleSetThumbnail}
          fileType="img"
        />
      )}
    </Grid>
  );
}

const styles = {
  contentStyle: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '150%',
    display: 'flex',
    alignItems: 'center',
    color: '#000000',
  },
  textFieldStyle: {color: '#FF5C00', width: '100%'},
  container: {padding: 10},
};
